import React from "react";
import { Container, Row } from "react-bootstrap";
import ContentSkeleton from "./ContentSkeleton";
import ImageSkeleton from "./ImageSkeleton";

const MissonSkeleton = () => {
  return (
    <Container>
      <Row>
        <ContentSkeleton />
        <ImageSkeleton />
      </Row>
    </Container>
  );
};

export default MissonSkeleton;
